import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-wrap items-center gap-2",
  "data-testid": "pin-step-header"
}
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = {
  key: 0,
  class: "mx-1 h-px w-6 bg-gray-200"
}

import { mdiCheck } from '@mdi/js'
import SVGIcon from '@/components/SVGIcon.vue'
import type { PinStep } from './pinModalTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'PinStepHeader',
  props: {
    step: {}
  },
  setup(__props: any) {

const props = __props;



const STEPS: { step: PinStep; label: string }[] = [
  { step: 1, label: 'Encontrar' },
  { step: 2, label: 'Posicionar' },
  { step: 3, label: 'Confirmar' }
]

/** O passo atual é o único preenchido; os concluídos ficam em check, os futuros em cinza. */
function badgeClass(step: PinStep): string {
  if (step === props.step) return 'bg-[#2F7F91] text-white'
  if (step < props.step) return 'bg-[#2F7F91]/10 text-[#2F7F91]'
  return 'bg-gray-100 text-gray-400'
}

function labelClass(step: PinStep): string {
  if (step === props.step) return 'font-semibold text-gray-800'
  if (step < props.step) return 'text-gray-600'
  return 'text-gray-400'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(STEPS, (item, index) => {
      return _createElementVNode("li", {
        key: item.step,
        class: "flex items-center gap-2"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold", badgeClass(item.step)]),
          "data-testid": `pin-step-badge-${item.step}`
        }, [
          (item.step < _ctx.step)
            ? (_openBlock(), _createBlock(SVGIcon, {
                key: 0,
                path: _unref(mdiCheck),
                class: "text-sm"
              }, null, 8, ["path"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(item.step), 1)
              ], 64))
        ], 10, _hoisted_2),
        _createElementVNode("span", {
          class: _normalizeClass(["text-sm", labelClass(item.step)])
        }, _toDisplayString(item.label), 3),
        (index < STEPS.length - 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : _createCommentVNode("", true)
      ])
    }), 64))
  ]))
}
}

})